const options = {
  0: "lg:border-l-0",
  1: "lg:border-l",
  2: "lg:border-l-2",
  4: "lg:border-l-4",
  8: "lg:border-l-8",
};

export default function getBorderLeftLg(width) {
  return options[width];
}
